<template>
    <section v-if="gptLoaded !== null">
        <template v-if="adBlockDetected || gptLoaded === false">
            <slot v-if="$slots.default && !plugStaticBlock" />
            <AdBlockPlaceholder
                v-else
                :id="id"
                :placeholder-data="placeholderData"
                :progressive-image="progressiveImage"
                @error="emitPlaceHolderError"
            />
        </template>
        <DoubleClickWrapper
            v-else
            :id="id"
        />
    </section>
</template>

<script>
import { mapState } from 'vuex';
import AdBlockPlaceholder from '~/components/common/DoubleClick/components/AdBlockPlaceholder';
import DoubleClickWrapper from '~/components/common/DoubleClick/components/DoubleClickWrapper';
import inventory from '~/assets/services/doubleClick/api.config';

export default {
    name: 'DoubleClick',
    components: { DoubleClickWrapper, AdBlockPlaceholder },
    props: {
        id: {
            type: String,
            default: '',
        },
        placeholderData: {
            type: Object,
            default: null,
        },
        progressiveImage: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            adBlockDetected: state => state.adblock,
            gptLoaded: state => state.googleServices.GPT,
        }),
        plugStaticBlock() {
            const socket = inventory.find(slot => slot.id === this.id);
            return socket.plugStaticBlock;
        },
    },
    methods: {
        emitPlaceHolderError({ id }) {
            this.$emit('placeholderError', { id });
        },
    },
};
</script>
